import { noop } from '@silverhand/essentials';
import { createContext } from 'react';

export default createContext<() => void>(noop);
